/* eslint-disable react/no-array-index-key */
import React from 'react';

export function FileExplorerTreeSkeleton({ length }: { length: number }) {
  return (
    <ul className="file-explorer-list placeholder-glow">
      {Array.from({ length }).map((_, index) => (
        <li className="file-explorer-list__item" key={`file-explorer-file-tree-skeleton-${index}`}>
          <div className="file-explorer-tree-button placeholder-glow">
            <div className="p-3 col-2 rounded placeholder bg-gray-300" />
            <div className="p-3 col-9 rounded placeholder bg-gray-300" />
          </div>
        </li>
      ))}
    </ul>
  );
}
